
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/view/[articleId]",
      function () {
        return require("private-next-pages/article/view/[articleId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/view/[articleId]"])
      });
    }
  